import mweixin from '../report/report_base.js';
import * as base from '../base/mbase.js';
import * as str from '../base/string.js';
import env from '../common/env.js';


var getQueryStr  = base.getQueryStr;


import Dom from '../base/mdom.js';
var top         = Dom.window;
/*

 */
let exportData;
(function (_aoExport, win, doc) {
    "use strict";
    //上报类型中的device必须是字符串，
    //iphone,android-lite-,android,symbian60v3,symbian60v5,
    //wp7,webwx,blackberry-,wp8,s40asha v5,s40asha,BlackBerry10-,其他字符串
    var _reportObj = _aoExport.reportObj;

    function extendExternInfo(obj) {
        var rpt_ssid_str = getQueryStr('rpt_ssid_str') || '';
        var externinfo = obj.sExternInfo;

        try {
            if (!rpt_ssid_str) return obj;

            if (!externinfo) {
                externinfo = JSON.stringify({ rpt_ssid_str: rpt_ssid_str });
            } else {
                if (typeof externinfo === 'string') {

                    var externinfo_obj = JSON.parse(externinfo);
                    externinfo_obj = base.extend({ rpt_ssid_str: rpt_ssid_str }, externinfo_obj);
                    externinfo = JSON.stringify(externinfo_obj);

                } else if (typeof externinfo === 'object') {

                    externinfo = JSON.stringify(base.extend({ rpt_ssid_str: rpt_ssid_str }, externinfo));

                }
            }

            obj.sExternInfo = externinfo;

            return obj;
        } catch (e) {
            return obj;
        }
    }

    //11332 平台类上报
    function batch16145(list, _slogin, cbk) {
        if(env.isMSDK || !env.isWechat) return;

        var xhr = new XMLHttpRequest(),
            _report = [];
        xhr.onreadystatechange = function () {};
        for (var i = 0, il = list.length; i < il; i++) {
            var _o = list[i],
                _sUrl = '';

            _o = extendExternInfo(_o);
            //这是第一个key，不要增加一个&
            _sUrl += "PageKey="                + (_o.PageKey 
                                                                    || _reportObj.PageKey 
                                                                    || '');

            _sUrl += "&Network="                + (_o.sConnectType 
                                                                    || _reportObj.networktype 
                                                                    || "");

            _sUrl += "&DeviceLevel="            + (_o.DeviceLevel   || '');
            _sUrl += "&Url="                    + encodeURIComponent(Dom.window.location.href);

            _sUrl += "&IsWepkg="                + (_o.IsWepkg       || 0);          // 0 为非wepkg,1 为 wepkg
            _sUrl += "&IsLuggage="              + (_o.IsLuggage     || 0);          // 0 为非 luggage,1 为 luggage
            _sUrl += "&IsPreload="              + (_o.IsPreload     || 0);          // 0 为不预加载 ,1 为预加载
            _sUrl += "&WepkgVersion="           + (_o.WepkgVersion  || '');
            _sUrl += "&CommJsVersion="          + (_o.CommJsVersion || '');
            _sUrl += "&Type="                   + (_o.Type          || 0);
            _sUrl += "&Target="                 + (_o.Target        || '');

            

            _sUrl += "&Params="                 + (_o.Params        || '');
            _sUrl += "&Result="                 + (_o.Result        || '');
            _sUrl += "&CostTime="               + (_o.CostTime      || 0);
            _sUrl += "&CurrentUrl="             + encodeURIComponent(Dom.window.location.href);
            
            _sUrl += "&IsError="                + (_o.IsError       || 0);
            
            if(window.__KULP_BUILD_VERSION__) {
                _sUrl += '&BuildVersion='       + (window.__KULP_BUILD_VERSION__ || "");
            }
            var strObj = str.strToMap(_sUrl,'&','=');
            
            _report.push(strObj);
        }
        var method = _report.length > 1 ? 'POST' : 'GET';
        
        
        var qryStr = '/cgi-bin/gamewxagcommwap/report?' 
                    + (_report.length > 1 ? '' : '' + str.mapToStr(_report[0]))
                    + "&QB&";
                    
        xhr.open(method, qryStr, true);
        
        if (_report.length > 1) {
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        }
        xhr.send(_report.length > 1 ? JSON.stringify({
            batchdata:_report
        }) : null);
    }
    exportData = batch16145;
})(mweixin, window, document);
export default exportData;